const codePrefixes: any = {
  acquisitions: 'AQID',
  users: 'USID',
  legacySticker: 'LEGACY_STICKER',
}
export default codePrefixes
